<template>
  <el-card>
    <template #header>
      <span>有权限查看公司</span>
    </template>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="开发者关联公司" name="first">
        <div style="margin: 10px 15px 10px 15px;">
          <el-table :data="itemDeveloperCompanyList" style="width: 100%;text-align: center; height: 100%; " border ref="refTable"
                    :header-cell-style="{ background: '#F2F2F2', color: '#333' }">
            <el-table-column prop="companyId" label="公司id" width="80" show-overflow-tooltip align="center"/>
            <el-table-column prop="companyName" label="公司名称" min-width="180" show-overflow-tooltip align="center"/>
            <el-table-column prop="createTime" label="创建时间" min-width="180" show-overflow-tooltip align="center"/>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="普通用户关联公司" name="second">
        <div style="margin: 10px 15px 10px 15px;">
          <el-table :data="itemCompanyList" style="width: 100%;text-align: center; height: 100%; " border ref="refTable"
                    :header-cell-style="{ background: '#F2F2F2', color: '#333' }">
            <el-table-column prop="companyId" label="公司id" width="80" show-overflow-tooltip align="center"/>
            <el-table-column prop="companyName" label="公司名称" min-width="180" show-overflow-tooltip align="center"/>
            <el-table-column prop="createTime" label="创建时间" min-width="180" show-overflow-tooltip align="center"/>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
import API from "../../../../../config/api";

export default {
  data() {
    return {
      activeName: 'first', //默认选中的tab
      itemCompanyList: [],  //普通用户有权限查看的公司列表
      itemDeveloperCompanyList: [], //开发者身份的公司
      companyId: '',
      userId: '',
    }
  },
  mounted() {
    // 获取该用户普通用户身份的公司
    this.getPermissionCompanyList();
    //获取该用户开发者身份的公司
    this.getDeveloperCompanyList();
    this.userId = window.localStorage.getItem('userid');
    console.log('公司列表userId的值=', this.userId);
  },

  methods: {
    //页面切换
    handleClick(tab) {
      console.log(tab);
      this.activeName = tab.name;
    },
    getPermissionCompanyList() {
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      let data = {
        role_type: 1
      }
      this.$axiosRequest({
        url: API.getUserCompanyList,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          this.itemCompanyList = res.data["companyList"];
        }
      });
    },
    getDeveloperCompanyList() {
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      let data = {
        role_type: 0
      }
      this.$axiosRequest({
        url: API.getUserCompanyList,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          this.itemDeveloperCompanyList = res.data["companyList"];
        }
      });
    },
  },
}
</script>

<style lang="less">
swiper {
  height: 400px;

  image {
    width: 100%;
  }
}

.info-title {
  font-size: 18px;
  font-weight: bold;
  color: #004768;
  font-family: '仿宋';
}

.info-content {
  font-size: 18px;
  font-family: '仿宋';
  // font-weight: bold;
}

.info-card {
  margin: 10px 15px 10px 15px; // 上 右 下 左
  padding: 24px;
  background-color: rgba(240, 240, 240, 0.7);
}

.info-content {
  margin: 10px 0px 10px 10px; // 上 右 下 左
  height: auto;
}

.title-style {
  font-size: 18px;
  font-weight: bold;
}

.title2-style {
  font-size: 15px;
  //font-weight: bold;
  line-height: 40px;
}

.title3-style {
  font-size: 12px;
  line-height: 40px;
  color: gray
}

.button-group-card {
  margin: 10px 15px 10px 15px; // 上 右 下 左
  background-color: rgba(240, 240, 240, 0.5);
  padding: 24px;
}

.button-group-title {
  font-size: 18px;
  font-weight: bold;
}
</style>

